export const clearUnicodeLiteralsStr = (str) => {
    // matches unicode C0 controls [U+0001...U+001F]
    const unicodeLiterals = /(?<=[^\\]|^)\\u00(0[1-9A-F]|1[0-9A-F])/gim;
    return str.replace(unicodeLiterals, "");
};
export const clearUnicodeLiterals = (cv) => {
    const clearedStringifiedCV = clearUnicodeLiteralsStr(JSON.stringify(cv));
    return JSON.parse(clearedStringifiedCV);
};
